import React from 'react';
import { SelectionCard } from '../SelectionCard/SelectionCard';
import { Title } from '../Title/Title';
import { Disclaimer } from '../Disclaimer/Disclaimer';
import { querySelectionCardElectricity, querySelectionCardGas, ENQUIRY_TITLE, DISCLAIMER } from '../../config/AppConfigurator';

/* IMPORTING QUERY SELECTION STYLES */
import '../../assets/components/QuerySelection.scss'; 

export const QuerySelection = ({ QuerySelectionFactory }) => {
    
    return (
        <>
            <div data-testid="query-selection-title" className="query-selection-title">
                <Title title={ ENQUIRY_TITLE } />
            </div>
            <div className="query-selection">
                <div className="row gy-3">
                    <div data-testid="selection-card-1" className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <SelectionCard {...querySelectionCardElectricity } selectionType={ QuerySelectionFactory }/>
                    </div>
                    <div data-testid="selection-card-2" className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                        <SelectionCard  {...querySelectionCardGas} selectionType={ QuerySelectionFactory }/>
                    </div>
                </div>
                <div data-testid="disclaimer" className="query-selection-disclaimer">
                    <Disclaimer disclaimer={ DISCLAIMER } />
                </div>
            </div>
        </>
    );
};
